import { useConversations } from '../conversation/useConversations'
import { useConversationUuid } from '../conversation/useConversationUuid'
import { useTaskObj } from './useTaskObj'

export function useTaskId() {
  const {conversations} = useConversations()
  const uuid = useConversationUuid()

  const taskIdFromConversations = conversations.find(
    conversation => conversation.uuid === uuid
  )?.task_id
  const taskIdFromTaskObj = useTaskObj()?.task_id

  const taskId = taskIdFromTaskObj || taskIdFromConversations
  return taskId
}
